import SpeedDoughnut from './components/SpeedDoughnut.vue';
import DougnutChart from './charts/DougnutChart.vue';
import InsightLineChart from './components/InsightLineChart.vue';
import StackedBarChart from './components/StackedBarChart.vue';
import HybridChart from './components/HybridChart.vue';

export { SpeedDoughnut, DougnutChart, InsightLineChart, StackedBarChart, HybridChart };
